import { z } from 'zod';
import { Maybe } from '../../../utils/apollo/graphqlSchema';
import { EmailInputError } from '../types';
import { emailInputErrorValues } from './utils';

const emailValidationSchema = z.object({
  email: z.string().email(),
});

const validateEmail = (
  email: string,
  allowedDomains?: string[],
): Maybe<{ error: string }> => {
  const lowercasedEmail = email.trim().toLowerCase();
  const isValidFormat = emailValidationSchema.safeParse({
    email: lowercasedEmail,
  }).success;

  // First check format
  if (!isValidFormat) {
    return {
      error: emailInputErrorValues[EmailInputError.Format],
    };
  }

  // If provided, check domain
  if (allowedDomains && allowedDomains.length > 0) {
    const domainIsValid = allowedDomains.some((domain) => {
      // Check if domain starts with @ to avoid '@ABCkubit.co' match 'kubit.co'
      const searchString = domain.startsWith('@') ? domain : `@${domain}`;
      return lowercasedEmail.endsWith(searchString);
    });

    if (!domainIsValid) {
      return {
        error: emailInputErrorValues[EmailInputError.Domain],
      };
    }
  }

  return null;
};

export default validateEmail;
